var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 78,
    viewBox: "0 0 117 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_977_1580)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_977_1580",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 3C114 1.89543 113.105 1 112 1H5C3.89543 1 3 1.89543 3 3V62C3 63.1046 3.89543 64 5 64H8.49445C9.20898 64 9.86923 64.3812 10.2265 65L14.2679 72C15.0377 73.3333 16.9623 73.3333 17.7321 72L21.7735 65C22.1308 64.3812 22.791 64 23.5056 64H112C113.105 64 114 63.1046 114 62V3Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 3C114 1.89543 113.105 1 112 1H5C3.89543 1 3 1.89543 3 3V62C3 63.1046 3.89543 64 5 64H8.49445C9.20898 64 9.86923 64.3812 10.2265 65L14.2679 72C15.0377 73.3333 16.9623 73.3333 17.7321 72L21.7735 65C22.1308 64.3812 22.791 64 23.5056 64H112C113.105 64 114 63.1046 114 62V3Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7735 65L20.9075 64.5L21.7735 65ZM14.2679 72L15.134 71.5L14.2679 72ZM17.7321 72L16.866 71.5L17.7321 72ZM10.2265 65L9.36047 65.5L10.2265 65ZM5 2H112V0H5V2ZM4 62V3H2V62H4ZM8.49445 63H5V65H8.49445V63ZM15.134 71.5L11.0925 64.5L9.36047 65.5L13.4019 72.5L15.134 71.5ZM20.9075 64.5L16.866 71.5L18.5981 72.5L22.6395 65.5L20.9075 64.5ZM112 63H23.5056V65H112V63ZM113 3V62H115V3H113ZM112 65C113.657 65 115 63.6569 115 62H113C113 62.5523 112.552 63 112 63V65ZM22.6395 65.5C22.8182 65.1906 23.1483 65 23.5056 65V63C22.4338 63 21.4434 63.5718 20.9075 64.5L22.6395 65.5ZM13.4019 72.5C14.5566 74.5 17.4434 74.5 18.5981 72.5L16.866 71.5C16.4811 72.1667 15.5189 72.1667 15.134 71.5L13.4019 72.5ZM8.49445 65C8.85171 65 9.18184 65.1906 9.36047 65.5L11.0925 64.5C10.5566 63.5718 9.56624 63 8.49445 63V65ZM2 62C2 63.6569 3.34314 65 5 65V63C4.44771 63 4 62.5523 4 62H2ZM112 2C112.552 2 113 2.44771 113 3H115C115 1.34315 113.657 0 112 0V2ZM5 0C3.34315 0 2 1.34315 2 3H4C4 2.44772 4.44772 2 5 2V0Z",
    fill: "#C7C7C7",
    fillOpacity: 0.4,
    mask: "url(#path-1-inside-1_977_1580)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_977_1580",
    x: 0,
    y: 0,
    width: 117,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_977_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_977_1580",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordBalloon);
export default __webpack_public_path__ + "static/media/wordBalloon.90db2ccde9adbfaa7263451f7223850c.svg";
export { ForwardRef as ReactComponent };